/*
 * 由于历史将 $t 直接作为全局的方法，必须在任何业务 js 执行前先确保 i18n 可用
 * 将原本的 main 分为两部分
 * 1. 与 i18n 无关的，尽量提前加载和初始化。小心区分其依赖内部是否引用到 $t()
 * 2. app 入口。包括各 constants 其内部可能也用了 $t）
 * 将增加白屏时间
 */

// 确保排在最前
import '@/mod/aegis';
import '@/mod/monitoring/vue-runtime-error';

import { initI18n } from '@/i18n';
import { initProjectTimezone } from '@/service/project-timezone';

const initI18nTask = initI18n();
const initTimezoneTask = initProjectTimezone();

// 不等待，main-after-pre 里有实际的静态 import
Promise.allSettled([
  // 提前加载的资源名单，尽量减少 main-after-pre 才加载的延迟时间
  import('./main-auth0-plugin'), // auth0 内部有异步请求，尽量早加载
  import('@/styles/element-index.scss'),

  // @ts-ignore
  import('@tencent/bk-icon-abetterchoice-v2'),

  // @ts-ignore
  import('@tencent/bk-icon-abetterchoice-v2/src/index'),
  import('vue'),
  import('vue-router'),
  import('pinia'),
  import('element-plus'),
  import('@element-plus/icons-vue'),
  import('@tencent/ti18n-vue3-sdk'),
  import('@tencent/tab-ui-plus'),
  import('dayjs'),
  import('dayjs/plugin/duration'),
]);

const initDayjsTask = Promise.all([
  import('dayjs'),
  import('dayjs/plugin/duration'),
]).then(([dayjs, duration]) => {
  dayjs.extend(duration.default);
});

(async () => {
  await Promise.all([initI18nTask, initTimezoneTask, initDayjsTask]);

  // 在 main-after-pre 的静态 import 链求值前完成 ABC_FF 初始化，
  // 保证业务模块顶层引用 ABC_FF 时 window.ABC_FF 已存在。
  const [{ initAbcFf }, { env }] = await Promise.all([
    import('@/feature-flags/runtime/install'),
    import('@/env'),
  ]);
  initAbcFf(env.bizPlatform);

  await import('./main-after-pre');
})();
